<template>
    <div class="mb-6">
      <vx-card :subtitle="$t('view_member.block.detailed_report.'+ assessmentName +'_title')" class="drop-shadow">
        <symptom-report-assessment :isExpanded ="isExpandedState" :showHistory="showHistory" :assessment-data="assessmentData" />
        <div class="history-button mt-3" >
            <vs-button v-if="isExpandedState" @click="toggleState" color="secondary" size="small">
                {{ $t('view_member.block.detailed_report.' + (showHistory ? 'hide_history' : 'show_history')) }}
            </vs-button>
        </div>
        <div class="chevron-container">
          <vs-button class="chevron-button" @click="toggleExpand" size="small">
            <feather-icon
              class="icon-chevron"
              :icon="isExpandedState ? 'ChevronUpIcon' : 'ChevronDownIcon'"
            />
          </vs-button>
        </div>
      </vx-card>
    </div>
  </template>

<script>
import SymptomReportAssessment from '@/views/app/view_member/symptom_report/symptom-report-assessment';
import { ResourceImpl } from 'hal-client';

export default {
  name: 'DetailedReport',
  components: { SymptomReportAssessment },
  props: {
    memberResource: ResourceImpl,
    assessmentName: String
  },
  data () {
    return {
      showHistory: false,
      isExpandedState: false
    };
  },
  computed: {
    assessmentData () {
      return this.memberResource.$getEmbedded('user-assessment-symptom-report').filter(item => item.assessmentName === this.assessmentName);
    },
    displayData () {
      const sortedData = [...this.assessmentData].sort((a, b) => new Date(a.assessmentDate) - new Date(b.assessmentDate));

      const formattedData = sortedData.map((assessment, index, array) => ({
        date: new Date(assessment.assessmentDate).toLocaleDateString(), // Formatted date
        sum: assessment.userAnswers.reduce((acc, curr) => acc + parseInt(curr.response, 10), 0),
        change: index > 0 ? assessment.userAnswers.reduce((acc, curr) => acc + parseInt(curr.response, 10), 0) - array[index - 1].userAnswers.reduce((acc, curr) => acc + parseInt(curr.response, 10), 0) : 'null'
      }));
      while (formattedData.length < 2) {
        formattedData.push({ date: 'Coming', sum: 0, change: '-' });
      }
      return formattedData;
    }
  },
  methods: {
    toggleExpand () {
      this.isExpandedState = !this.isExpandedState;
    },
    toggleState () {
      this.showHistory = !this.showHistory;
    }
  }
};
</script>

  <style scoped>
  .chevron-container {
    text-align: center;
    position: absolute;
    left: 50%;
    bottom: -20px; /* Adjust so that the button is placed correctly */
    transform: translateX(-50%);
  }
  .history-button{
    text-align: center;
  }
  .chevron-button {
    border: none; /* Removes border */
    box-shadow: none; /* Removes shadow if there is any */
    width: 100%; /* Set the desired width */
    justify-content: center; /* Centers the icon horizontally */
    align-items: bottom; /* Aligns the icon to the bottom */
    height: 25px; /* Adjust height as needed */
    color: grey !important;
    margin: 2px !important;
    border-radius: 0px 0px 8px 8px;
    background: var(--FFFFFF-Secondary, #FFF) !important;

  }
  .icon-chevron{
    width: 18px;
    height: 18px;
  }
  </style>
